import { EGENDER, EQuizId } from 'types/quiz';
export interface IQuizData {
    id: EQuizId;
    displayOrder: number;
    gender?: EGENDER;
}

export enum EQuizOrder {
    GENDER = 1,
    BIRTHDAY = 2,
    PERSONA = 3,
    BODY_SHAPE = 4,
    BODY_TYPE = 5,
    SKIN_TONE = 6,
    SKIN_UNDERTONE = 7,
    HAIR_COLOR = 8,
    EYE_COLOR = 9,
    MEASUREMENT = 10,
    MY_PHOTOS = 11,
    STYLE_QUIZ = 12,
    COLOR = 13,
    PATTERN = 14,
    HIJAB = 15,
    SHOW_OFF = 16,
    COVER = 17,
    FASHION_RESTRICTION = 18,
    SIZES = 19,
    BUDGET = 20,
    BRANDS = 21,
}

export const quiz_data: IQuizData[] = [
    {
        id: EQuizId.GENDER_QUIZ,
        displayOrder: 0,
    },
    {
        id: EQuizId.MY_BIRTHDAY_QUIZ,
        displayOrder: 1,
    },
    {
        id: EQuizId.PERSONAS_FEMALE_QUIZ,
        gender: EGENDER.FEMALE,
        displayOrder: 2,
    },
    {
        id: EQuizId.PERSONAS_MALE_QUIZ,
        gender: EGENDER.MALE,
        displayOrder: 2,
    },
    {
        id: EQuizId.STYLE_QUIZ_WOMAN,
        gender: EGENDER.FEMALE,
        displayOrder: EQuizOrder.STYLE_QUIZ,
    },
    {
        id: EQuizId.STYLE_QUIZ_MAN,
        gender: EGENDER.MALE,
        displayOrder: EQuizOrder.STYLE_QUIZ,
    },
    {
        id: EQuizId.BODY_SHAPE,
        displayOrder: EQuizOrder.BODY_SHAPE,
    },
    {
        id: EQuizId.BODY_TYPE,
        displayOrder: EQuizOrder.BODY_TYPE,
    },
    {
        id: EQuizId.SKIN_TONE,
        displayOrder: EQuizOrder.SKIN_TONE,
    },
    {
        id: EQuizId.SKIN_UNDERTONE,
        displayOrder: EQuizOrder.SKIN_UNDERTONE,
    },
    {
        id: EQuizId.HAIR_COLOR,
        displayOrder: EQuizOrder.HAIR_COLOR,
    },
    {
        id: EQuizId.EYE_COLOR,
        displayOrder: EQuizOrder.EYE_COLOR,
    },
    {
        id: EQuizId.MEASUREMENTS_QUIZ_FEMALE,
        gender: EGENDER.FEMALE,
        displayOrder: EQuizOrder.MEASUREMENT,
    },
    {
        id: EQuizId.MEASUREMENTS_QUIZ_MALE,
        gender: EGENDER.MALE,
        displayOrder: EQuizOrder.MEASUREMENT,
    },
    {
        id: EQuizId.MY_PHOTOS_QUIZ,
        displayOrder: EQuizOrder.MY_PHOTOS,
    },
    {
        id: EQuizId.COLOR_QUIZ,
        displayOrder: EQuizOrder.COLOR,
    },
    {
        id: EQuizId.FASHION_RESTRICTION_QUIZ_WOMAN,
        gender: EGENDER.FEMALE,
        displayOrder: EQuizOrder.FASHION_RESTRICTION,
    },
    {
        id: EQuizId.FASHION_RESTRICTION_QUIZ_MAN,
        gender: EGENDER.MALE,
        displayOrder: EQuizOrder.FASHION_RESTRICTION,
    },
    {
        id: EQuizId.SIZES_MALE,
        displayOrder: EQuizOrder.SIZES,
        gender: EGENDER.MALE,
    },
    {
        id: EQuizId.SIZE_FEMALE,
        displayOrder: EQuizOrder.SIZES,
        gender: EGENDER.FEMALE,
    },
    {
        id: EQuizId.HIJAB,
        displayOrder: EQuizOrder.HIJAB,
    },
    {
        id: EQuizId.PATTERN_QUIZ_MAN,
        gender: EGENDER.MALE,
        displayOrder: EQuizOrder.PATTERN,
    },
    {
        id: EQuizId.PATTERN_QUIZ_WOMAN,
        gender: EGENDER.FEMALE,
        displayOrder: EQuizOrder.PATTERN,
    },
    {
        id: EQuizId.BUDGET_WOMAN_QUIZ,
        gender: EGENDER.FEMALE,
        displayOrder: EQuizOrder.BUDGET,
    },
    {
        id: EQuizId.BUDGET_MAN_QUIZ,
        gender: EGENDER.MALE,
        displayOrder: EQuizOrder.BUDGET,
    },
    {
        id: EQuizId.SHOW_OFF,
        displayOrder: EQuizOrder.SHOW_OFF,
    },
    {
        id: EQuizId.COVER,
        displayOrder: EQuizOrder.COVER,
    },
];

export const getQuizData = (displayOder: number, gender?: EGENDER) => {
    return quiz_data.find(
        (item) => item.displayOrder === displayOder && item.gender?.toLowerCase() === gender?.toLowerCase(),
    );
};
